export default __webpack_public_path__ + "static/media/upload-icon.73a112a6.svg";